import { Controller } from 'stimulus'
import Swal from 'sweetalert2'

export default class extends Controller {

  async openPopupForm(e) {
    const updateUrl = e.currentTarget.dataset.updateUrl
    const params = e.currentTarget.dataset.params
    const title = e.currentTarget.dataset.title
    const input = e.currentTarget.dataset.input
    const status = e.currentTarget.dataset.status

    if (status === 'incubated') {
      const { value: formValue } = await Swal.fire({
        title: title,
        html: '<input id="incubation_end_date" type="date" class="input" /> <br></br>' +
              '<textarea input id="incubation_comments" placeholder="Comentarios" class="input" />',
        type: 'question',
        focusConfirm: false
      })

      if (formValue) {
        const formData = "deal[status]=" + status + "&" +
                         "deal[incubation_end_date]=" + incubation_end_date.value + "&" +
                         "deal[incubation_comments]=" + incubation_comments.value
        Rails.ajax({
          type: "patch",
          dataType: 'json',
          url: updateUrl,
          data: formData,
          error: function(data) { alert(data) }
        })
      }
    } else if (status === 'canceled') {
      const cancelReasons = e.currentTarget.dataset.cancelReasons

      const { value: selectedReason } = await Swal.fire({
        title: title,
        input: 'select',
        inputOptions: JSON.parse(cancelReasons),
        inputPlaceholder: 'Selecciona un motivo de rechazo',
        customClass: { input: 'input' },
        showCancelButton: true
      })

      if (selectedReason) {
        const formData = `deal[status]=${status}&deal[lost_reason]=${selectedReason}`

        Rails.ajax({
          type: "patch",
          dataType: 'json',
          url: updateUrl,
          data: formData,
          error: function(data) { alert(data) }
        })
      }
    } else {
      const { value: formValue } = await Swal.fire({
        title: title,
        input: input,
        focusConfirm: false,
        preConfirm: (reconsiderationText) => {
          return reconsiderationText
        }
      })

      if (formValue) {
        console.log(formValue)
        Rails.ajax({
          type: "patch",
          dataType: 'json',
          url: updateUrl,
          data: params + formValue,
          error: function(data) { alert(data) }
        })
      }
    }
  }
}
